export default "__VITE_ASSET__DmOImMFj__"